import * as PropTypes from 'prop-types';
import React from 'react';
import translate from '../functions/translate';
import H2 from './h2';
import H6 from './h6';

const StepHeader = props => {
   const {currentStep, numSteps, stepTitle} = props;
   return <>
      <legend>
         <H6>{`${translate('Step')} ${currentStep} ${translate('of')} ${numSteps}`}</H6>
         <H2 style={{marginTop: 0}}>{stepTitle}</H2>
      </legend>
   </>;
};

StepHeader.propTypes = {
   currentStep: PropTypes.number,
   numSteps: PropTypes.number,
   stepTitle: PropTypes.string
};

export default StepHeader;